import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/arrow.up.svg'


const _hoisted_1 = { class: "listFilterHeader" }
const _hoisted_2 = {
  key: 0,
  class: "listFilterSideBox",
  ref: "listFilterSideBox"
}
const _hoisted_3 = { class: "fs_12 fw_500" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex justify-content-center mt-3 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_filter_container = _resolveComponent("time-filter-container")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_ticket_card = _resolveComponent("ticket-card")!
  const _component_technician_detail = _resolveComponent("technician-detail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_time_filter_container, {
        onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.timeFilter = $event)),
        class: "widthAsSideBox"
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.resultsList.length) + " / " + _toDisplayString(_ctx.tickets.totalItems) + " ", 1),
            _createVNode(_component_localized_text, {
              class: "fw_500",
              localizedKey: "risultati",
              text: "risultati"
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsList, (ticket, index) => {
            return (_openBlock(), _createBlock(_component_ticket_card, {
              ticket: ticket,
              hideDate: _ctx.timeFilter == _ctx.nextFilterName,
              onTechnicianSelected: _ctx.selectTecnico,
              key: index
            }, null, 8, ["ticket", "hideDate", "onTechnicianSelected"]))
          }), 128)),
          (_ctx.showScrollTopButton)
            ? (_openBlock(), _createBlock(_Transition, {
                key: 0,
                name: "opacity",
                class: "duration04",
                appear: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "scrollTopButton",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToTop()))
                  }, _hoisted_5)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.resultsList.length < _ctx.tickets.totalItems)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button buttonAsLink",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moreData()))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Mostra più risultati",
                    text: "Mostra più risultati"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.technicianDetails)
      ? (_openBlock(), _createBlock(_component_technician_detail, {
          key: 1,
          technicianDetail: _ctx.technicianDetails,
          onCloseTecnicoDetailSection: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeTecnicoDetailSection()))
        }, null, 8, ["technicianDetail"]))
      : _createCommentVNode("", true)
  ], 64))
}